import styled from "vue-styled-components";

export const Content = styled.div`
    .modal {
        z-index: 5000;
        .modal-header {
            border: none;
        }
    }
`;
